import { render, staticRenderFns } from "./changeCatgory.vue?vue&type=template&id=310bfff7&scoped=true&"
import script from "./changeCatgory.vue?vue&type=script&lang=js&"
export * from "./changeCatgory.vue?vue&type=script&lang=js&"
import style0 from "./changeCatgory.vue?vue&type=style&index=0&id=310bfff7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310bfff7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/h5-web-gold/h5-web-gold/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('310bfff7')) {
      api.createRecord('310bfff7', component.options)
    } else {
      api.reload('310bfff7', component.options)
    }
    module.hot.accept("./changeCatgory.vue?vue&type=template&id=310bfff7&scoped=true&", function () {
      api.rerender('310bfff7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/suspends/changeCatgory.vue"
export default component.exports